import { z } from 'zod';

import { BaseDeckManagementEntry, createChangeSetOperations, nullableString } from './Common.schema';

export const AuditHistorySchema = BaseDeckManagementEntry.extend({
  page_id: z.string(),
  change_type: nullableString,
  before: nullableString,
  after: nullableString,
  user: nullableString,
  dateTime: nullableString,
  row: nullableString,
  page_name: nullableString,
});

/**
 * Schema for creating new AuditHistory entries.
 * Omits pk and sk fields as these are generated by the service.
 * Matches AuditHistoryItemsInput GraphQL type requirements.
 */
export const CreateAuditHistorySchema = AuditHistorySchema.omit({
  pk: true,
  sk: true,
});

/**
 * Complete changeset schema for AuditHistory operations.
 * Provides create array with appropriate validation.
 */
export const AuditHistoryChangeSetSchema = createChangeSetOperations({
  create: CreateAuditHistorySchema,
  update: z.array(z.any()).default([]), // Not used for Audit History
  delete: z.array(z.any()).default([]), // Not used for Audit History
});

/**
 * Type definitions for use in components and services
 */

/**
 * Type for AuditHistory entries in create operations (without pk/sk)
 */
export type CreateDecklineType = z.infer<typeof CreateAuditHistorySchema>;

/**
 * Type for the complete AuditHistory changeset structure
 */
export type AuditHistoryChangeSetType = z.infer<typeof AuditHistoryChangeSetSchema>;
